import React from "react";
import {
  HeaderContainer,
  SectionTitle,
  SectionSubtitle,
} from "./SectionHeader.styled";
import Rectangle from "../Rectangle/Rectangle";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  showRectangle?: boolean;
  color?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  subtitle,
  showRectangle = true,
  color,
}) => {
  return (
    <HeaderContainer>
      {showRectangle && <Rectangle width={"137px"} height={"16px"} />}
      <SectionTitle variant="h1" $color={color}>
        {title}
      </SectionTitle>
      {subtitle && (
        <SectionSubtitle variant="subtitle1">{subtitle}</SectionSubtitle>
      )}
    </HeaderContainer>
  );
};

export default SectionHeader;
